module.exports = __webpack_public_path__ + "img/statistic2.24108b53.png";